import { TResourceParams } from 'types/resource';
import { TResourceGroupParams } from 'types/resourceGroup';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ResourceEntityListResp } from '@api/responseModels/resource/resourceEntityList';
import { ResourceGroupListResp } from '@api/responseModels/resource/resourceGroupListResponse';
import { ResourceListResp } from '@api/responseModels/resource/resourceListResponse';
import { ResourceResp } from '@api/responseModels/resource/resourceResponse';
import { ResourceGroupResp } from '@api/responseModels/resource/resourceResponseGroup';

export class ResourceGroup extends CRMAPIBase {
    async getResourceList(params): Promise<RequestResult<ResourceListResp>> {
        const result = await this.get<ResourceListResp>('/resources', params);
        return result;
    }

    async getResource(id: number, crm_id: number): Promise<RequestResult<ResourceResp>> {
        const result = await this.get<ResourceResp>(`/resources/${id}`, { crm_id });
        return result;
    }

    async createResource(params: TResourceParams): Promise<RequestResult<ResourceResp>> {
        const result = await this.post<ResourceResp>('/resources', params);
        return result;
    }

    async updateResource(
        id: number,
        params: TResourceParams
    ): Promise<RequestResult<ResourceResp>> {
        const result = await this.put<ResourceResp>(`/resources/${id}`, params);
        return result;
    }

    async updateResourceCategories(
        crmId: number,
        resources: Array<{ id: number; resource_category_id: number }>
    ): Promise<RequestResult<ResourceResp>> {
        const result = await this.post<ResourceResp>('/resources/categories', {
            crm_id: crmId,
            resources,
        });
        return result;
    }

    async removeResource(id: number, crm_id: number): Promise<RequestResult<ResourceResp>> {
        const result = await this.delete<ResourceResp>(`/resources/${id}`, { crm_id });
        return result;
    }

    async getEntityListFromResource<T>(
        params,
        id
    ): Promise<RequestResult<ResourceEntityListResp<T>>> {
        const result = await this.get<ResourceEntityListResp<T>>(
            `/resources/${id}/related-data`,
            params
        );
        return result;
    }
    async getResourceGroupList(
        params: TResourceGroupParams
    ): Promise<RequestResult<ResourceGroupListResp>> {
        const result = await this.get<ResourceGroupListResp>('/resource-groups', params);
        return result;
    }
    async getResourceGroup(
        params: TResourceGroupParams
    ): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.get<ResourceGroupResp>(`/resource-groups/${params.id}`, params);
        return result;
    }
    async createResourceGroup(
        params: TResourceGroupParams
    ): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.post<ResourceGroupResp>('/resource-groups', params);
        return result;
    }
    async updateResourceGroup(
        params: TResourceGroupParams
    ): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.put<ResourceGroupResp>(`/resource-groups/${params.id}`, params);
        return result;
    }

    async removeResourceGroup(params: {
        id: number;
        crm_id: number;
    }): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.delete<ResourceGroupResp>(`/resource-groups/${params.id}`, {
            crm_id: params.crm_id,
        });
        return result;
    }
}
